module.exports = "/assets/images/logo-prahanabiji.206bbef4.png";